export default "__VITE_ASSET__Ch5fS6Cb__"